import { watch, type Ref } from 'vue'

export function useSelectionPop(
  selectionKey: Ref<string | null>,
  element: Ref<HTMLElement | undefined>,
) {
  watch(selectionKey, (key, previousKey) => {
    if (!key || !previousKey || key === previousKey) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    element.value?.animate([{ transform: 'scale(0.97)' }, { transform: 'scale(1)' }], {
      duration: 180,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      pseudoElement: '::before',
    })
  })
}
